module.exports = __webpack_public_path__ + "img/tasr.e51d78af.png";